/**
 * 食谱v2相关
 * 接口地址 http://rap2.10niu.cn/repository/editor?id=110&mod=591&itf=3984
 * 原型 https://u9qrwo.axshare.com/#g=1&p=%E9%A3%9F%E8%B0%B1%E8%AF%A6%E6%83%85
 */

import requestByGateway from '@/request/request.gateway';
import config from '@/config';
import qs from 'qs';

const recipesManagement = {
	// 获取食材分类列表
	getFoodClassList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/ingredient/ingredient_type_list`,
			headers: config.headers,
			params
		});
	},
	// 获取食材列表
	getFoodList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/ingredient/ingredient_list`,
			headers: config.headers,
			params
		});
	},
	// 删除食材
	deleteFood(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/ingredient/del_ingredient`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新增食材
	addFood(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/ingredient/add_ingredient`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑食材
	editFood(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/ingredient/edit_ingredient`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取菜肴列表
	getDishList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/dish/dish_list`,
			headers: config.headers,
			params
		});
	},
	// 获取菜肴分类列表
	getDishClassList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/dish/dish_type_list`,
			headers: config.headers,
			params
		});
	},
	// 删除菜肴 携带学校 id 删除菜肴
	deleteDishList(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/dish/del_dish`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 新增菜肴
	addDish(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/dish/add_dish`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 编辑菜肴
	editDish(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/dish/edit_dish`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 获取食材单位列表
	getFoodUnitList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/ingredient/unit_list`,
			headers: config.headers,
			params
		});
	},
	// 食谱_获取学校当前食谱配置版本
	getRecipeConfigVersion(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/recipe_config_version`,
			headers: config.headers,
			params
		});
	},
	// 食谱_设置学校食谱版本
	setRecipeConfigVersion(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/set_recipe_config_version`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 周食谱_列表
	getRecipeList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/week_recipe/list`,
			headers: config.headers,
			params
		});
	},
	// 周食谱_详情
	getRecipeInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/week_recipe/info`,
			headers: config.headers,
			params
		});
	},
	// 周食谱_删除
	deleteRecipe(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/week_recipe/del`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 周食谱_新增周食谱(带量)
	addRecipe(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/week_recipe/add`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 周食谱_编辑周食谱(带量)
	editRecipe(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/week_recipe/edit`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 周食谱_获取食谱月汇总
	getRecipeMonthSummary(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/recipe_month_summary`,
			headers: config.headers,
			params
		});
	},
	// 食材_获取食材营养分布
	getNutrientInfo(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/ingredient/nutrient_info`,
			headers: config.headers,
			params
		});
	},
	// 食材_获取食材营养分布
	exportRecipe(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/week_recipe/export`,
			headers: config.headers,
			data: qs.stringify(data)
		});
	},
	// 食谱_餐次_获取学校食谱餐次列表
	getMealList(params) {
		return requestByGateway({
			method: 'get',
			url: `${config.api.admin}/recipe/v1/meal/list`,
			params
		});
	},
	// 食谱_餐次_修改餐次名称
	mealUpdate(data) {
		return requestByGateway({
			method: 'post',
			url: `${config.api.admin}/recipe/v1/meal/update`,
			data: qs.stringify(data)
		});
	}
};

export default recipesManagement;
